import { createServiceManifest } from '@estee/elc-service';
import { events } from '@estee/elc-service-bus';
import { RampService } from './service-setup/RampService';
import { ELC_RAMP } from 'elc-service-view-names';

export const serviceViews = [ELC_RAMP];

export const serviceEvents = [
    events.RAMP_SIGN_UP_SUCCESSFUL,
    events.RAMP_SIGN_UP_FAILED,
    events.RAMP_LOG_IN_FAILED
];

const { name, version } = __serviceInfo__;

export const ServiceManifest = createServiceManifest<RampService>(
    {
        views: serviceViews,
        events: serviceEvents,
        name,
        version
    },
    () =>
        import(
            /* webpackChunkName: 'core' */
            './service-setup/diContainer'
        ),
    'rampService'
);
